import { render, staticRenderFns } from "./Crawler.vue?vue&type=template&id=2e315231&scoped=true&"
import script from "./Crawler.vue?vue&type=script&lang=js&"
export * from "./Crawler.vue?vue&type=script&lang=js&"
import style0 from "./Crawler.vue?vue&type=style&index=0&id=2e315231&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e315231",
  null
  
)

export default component.exports